import { doc, getDoc, setDoc } from 'firebase/firestore';
import { db } from '../firebase';

const consentService = {
  // Vérifier si consentement existe
  async hasHealthDataConsent(userId) {
    try {
      const consentDoc = await getDoc(doc(db, 'users', userId, 'consents', 'health_data'));

      if (!consentDoc.exists()) {
        return false;
      }

      const data = consentDoc.data();
      return data.accepted === true;
    } catch (error) {
      console.error('Erreur vérification consentement:', error);
      return false;
    }
  },

  // Enregistrer consentement
  async saveHealthDataConsent(userId) {
    try {
      await setDoc(doc(db, 'users', userId, 'consents', 'health_data'), {
        accepted: true,
        timestamp: new Date().toISOString(),
        ipAddress: null,
        userAgent: navigator.userAgent,
      });

      return true;
    } catch (error) {
      console.error('Erreur sauvegarde consentement:', error);
      throw error;
    }
  },

  // Révoquer consentement
  async revokeHealthDataConsent(userId) {
    try {
      await setDoc(doc(db, 'users', userId, 'consents', 'health_data'), {
        accepted: false,
        revokedAt: new Date().toISOString(),
      });

      return true;
    } catch (error) {
      console.error('Erreur révocation consentement:', error);
      throw error;
    }
  },
};

export default consentService;
